var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-list-container",class:{top: _vm.top, bottom: _vm.bottom}},[_c('div',{ref:"content",staticClass:"scroll-list-content",style:({'max-height': _vm.height})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }